import {
  IonBackButton,
  IonButton,
  IonButtons,
  IonCard,
  IonCardContent,
  IonCardHeader,
  IonCardSubtitle,
  IonCardTitle,
  IonCol,
  IonContent,
  IonGrid,
  IonHeader,
  IonPage,
  IonRow,
  IonToolbar,
  useIonViewDidEnter,
} from "@ionic/react";

import { useEffect, useState } from "react";
import { fetchQuestions } from "../questions";
import styles from "./Quiz.module.scss";

// React components
import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/css";

import { useRef } from "react";
import { useHistory } from "react-router";
import { Answer } from "../components/Answer";
import { CompletedCard } from "../components/CompletedCard";
import { QuizStats } from "../components/QuizStats";

const PostIcon = () => (
  <svg
    stroke="currentColor"
    fill="currentColor"
    stroke-width="0"
    viewBox="0 0 576 512"
    height="24"
    width="24"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path d="M561.938 158.06L417.94 14.092C387.926-15.922 336 5.097 336 48.032v57.198c-42.45 1.88-84.03 6.55-120.76 17.99-35.17 10.95-63.07 27.58-82.91 49.42C108.22 199.2 96 232.6 96 271.94c0 61.697 33.178 112.455 84.87 144.76 37.546 23.508 85.248-12.651 71.02-55.74-15.515-47.119-17.156-70.923 84.11-78.76V336c0 42.993 51.968 63.913 81.94 33.94l143.998-144c18.75-18.74 18.75-49.14 0-67.88zM384 336V232.16C255.309 234.082 166.492 255.35 206.31 376 176.79 357.55 144 324.08 144 271.94c0-109.334 129.14-118.947 240-119.85V48l144 144-144 144zm24.74 84.493a82.658 82.658 0 0 0 20.974-9.303c7.976-4.952 18.286.826 18.286 10.214V464c0 26.51-21.49 48-48 48H48c-26.51 0-48-21.49-48-48V112c0-26.51 21.49-48 48-48h132c6.627 0 12 5.373 12 12v4.486c0 4.917-2.987 9.369-7.569 11.152-13.702 5.331-26.396 11.537-38.05 18.585a12.138 12.138 0 0 1-6.28 1.777H54a6 6 0 0 0-6 6v340a6 6 0 0 0 6 6h340a6 6 0 0 0 6-6v-25.966c0-5.37 3.579-10.059 8.74-11.541z"></path>
  </svg>
);

function formatHashtag(str) {
  return "#" + str.replace(/[^a-zA-Z0-9]/g, "");
}

const Questions = () => {
  const mainContainerRef = useRef();
  const completionContainerRef = useRef();

  const [chosenCategory, setChosenCategory] = useState(false);
  const [chosenChapter, setChosenChapter] = useState(false);

  const [currentQuestion, setCurrentQuestion] = useState(1);
  const [score, setScore] = useState(0);
  const [completed, setCompleted] = useState(false);

  const [questions, setQuestions] = useState(false);
  const [slideSpace, setSlideSpace] = useState(0);
  const [fullscreen, setFullscreen] = useState(false);

  const history = useHistory();

  useEffect(() => {
    const queryParams = new URLSearchParams(history.location.search);

    setChosenCategory(queryParams.get("id"));
    setChosenChapter(queryParams.get("ch"));
    setFullscreen(!!queryParams.get("fullscreen"));
  }, [history.location]);

  useEffect(() => {
    const getQuestions = async () => {
      const fetchedQuestions = await fetchQuestions(
        chosenCategory,
        chosenChapter
      );
      setQuestions(fetchedQuestions);
    };

    if (chosenCategory) getQuestions();
  }, [chosenCategory, chosenChapter]);

  useIonViewDidEnter(() => {
    setSlideSpace(40);
  });

  const handleAnswerClick = (event, answer, question, swiper) => {
    const isCorrect = question.correct_answers[`${answer}_correct`] === "true";

    if (isCorrect) {
      event.target.setAttribute("color", "success");
    } else {
      event.target.setAttribute("color", "danger");
    }

    setTimeout(() => {
      isCorrect && setScore((score) => score + 1);
      event.target.setAttribute("color", "light");
      swiper.slideNext();
      checkIfComplete();
    }, 1000);
  };

  const checkIfComplete = () => {
    if (currentQuestion === questions.length) {
      //  Quiz has finished
      //  Hide Slides and show completion screen
      mainContainerRef.current.classList.add("animate__zoomOutDown");

      setTimeout(() => {
        setCompleted(true);
        completionContainerRef.current.classList.add("animate__zoomInUp");
      }, 1000);
    }
  };

  const handleShareClick = () => {
    // const question = questions[currentQuestion - 1];
    //     const message = `${question.question}
    // ${Object.keys(question.answers)
    //   .map((answer) =>
    //     question.answers[answer] ? `- ${question.answers[answer]}\n` : ""
    //   )
    //   .join("")}`;

    const url = `https://loonlog.ca/new-post?exam=${encodeURIComponent(
      `id=${chosenCategory}${chosenChapter ? `&ch=${chosenChapter}` : ""}`
    )}&post=${encodeURIComponent(`#quiz ${formatHashtag(chosenCategory)}`)}`;

    // const url = `https://loonlog.ca/post?post=${encodeURIComponent(
    //   `${message}\n\n${formatHashtag(chosenCategory)}`
    // )}`;
    window.open(url, "_blank");
  };

  return (
    <IonPage>
      {!fullscreen && (
        <IonHeader>
          <IonToolbar>
            <IonButtons slot="start">
              <IonBackButton defaultHref="/" />
            </IonButtons>
            <IonButtons slot="end">
              <IonButton
                fill="clear"
                onClick={handleShareClick}
                className={styles.shareButton}
              >
                <PostIcon />
              </IonButton>
            </IonButtons>
          </IonToolbar>
        </IonHeader>
      )}

      <IonContent fullscreen className={`${styles.background}`}>
        {!completed && (
          <IonGrid
            className={`${styles.mainGrid} animate__animated`}
            ref={mainContainerRef}
            style={{
              padding: 0,
            }}
          >
            <QuizStats
              chosenCategory={chosenCategory}
              chosenChapter={chosenChapter}
              questionsLength={questions.length}
              currentQuestion={currentQuestion}
              score={score}
            />

            <IonRow className={styles.mainRow}>
              <IonCol size="12">
                <IonRow>
                  <Swiper
                    spaceBetween={slideSpace}
                    slidesPerView={1}
                    onSlideChange={(e) => setCurrentQuestion(e.activeIndex + 1)}
                    allowTouchMove={false}
                  >
                    {questions &&
                      questions.length &&
                      questions.map((question, index) => {
                        return (
                          <SwiperSlide key={`question_${index}`}>
                            <IonCard
                              id="questionCard"
                              className="animate__animated"
                              style={{
                                margin: 0,
                              }}
                            >
                              <IonCardHeader className="ion-text-center">
                                <IonCardSubtitle>
                                  {chosenCategory}
                                </IonCardSubtitle>
                                {/* {question.tags.length > 0 && (
                                  <IonBadge color="success">
                                    {question.tags[0].name}
                                  </IonBadge>
                                )} */}
                                <IonCardTitle className={styles.questionTitle}>
                                  {question.question}
                                </IonCardTitle>
                              </IonCardHeader>

                              <IonCardContent>
                                {Object.keys(question.answers).map(
                                  (answer, index) => {
                                    if (question.answers[answer] !== null) {
                                      return (
                                        <Answer
                                          key={`answer_${index}`}
                                          answer={answer}
                                          question={question}
                                          handleAnswerClick={handleAnswerClick}
                                        />
                                      );
                                    }
                                  }
                                )}
                              </IonCardContent>
                            </IonCard>
                          </SwiperSlide>
                        );
                      })}
                  </Swiper>
                </IonRow>
              </IonCol>
            </IonRow>
          </IonGrid>
        )}

        {completed && (
          <CompletedCard
            completionContainerRef={completionContainerRef}
            score={score}
            questionsLength={questions.length}
            fullscreen={fullscreen}
          />
        )}
      </IonContent>
    </IonPage>
  );
};

export default Questions;

